<template>
  <l-modal full-height @close="handleClose">
    <l-modal-wrapper :direction="transitionDirection" :current-key="currentScreen">
      <companies-list
        v-if="currentScreen === 'list'"
        key="list"
        :title="t('generate-invoice.title')"
        @modify="handleModify"
        @select="handleSelect"
      />
      <company-editor
        v-else-if="currentScreen === 'editor'"
        key="editor"
        :company="selectedCompany"
        @save="handleSave"
        @back="handleBack"
      />
    </l-modal-wrapper>
  </l-modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { LModal, LModalWrapper } from '@last/core-ui/paprika'

import { type Company } from '@/types'

import CompaniesList from './CompaniesList.vue'
import CompanyEditor from './CompanyEditor.vue'

const emit = defineEmits<{
  close: []
  companySelected: [Company]
}>()

const { t } = useI18n()

type Screen = 'list' | 'editor'

const currentScreen = ref<Screen>('list')
const transitionDirection = ref<'forward' | 'backward'>('forward')
const selectedCompany = ref<Company>()
function handleSelect(company: Company) {
  emit('companySelected', company)
}

function handleModify(company?: Company) {
  selectedCompany.value = company
  transitionDirection.value = 'forward'
  currentScreen.value = 'editor'
}

function handleClose() {
  emit('close')
}

function handleBack() {
  transitionDirection.value = 'backward'
  currentScreen.value = 'list'
}

function handleSave(company: Company) {
  selectedCompany.value = company
  emit('companySelected', company)
}
</script>
